import { createContext } from 'react';

/**
 * Reader-widget UI state -- split out of the old, single
 * `pages/issue/Issue.context.tsx` (see `entities/issue/model/IssueContext.ts`'s
 * doc comment for the full split rationale). Not issue *data*: view mode
 * (replica/responsive), font size, favorites, and the audio player are all
 * reader-widget chrome, owned and typed here rather than by `pages/issue/`,
 * so `widgets/issue-reader/*` depends downward on its own context instead of
 * reaching up into `pages/`. `pages/issue/Issue.tsx` still owns the actual
 * `useState` calls and supplies the values in -- it just does so through a
 * shape this layer defines, not the other way around.
 */
export const ReaderStateContext = createContext<ReaderStateContextProps>({
	setMode: () => {},
	fontSize: 62.5,
	setFontSize: () => {},
	favorites: null,
	setFavorites: () => {},
	onClickLogOut: undefined,
	audioPlayerUrl: null,
	setAudioPlayerUrl: () => {},
	showAudioPlayer: false,
	setShowAudioPlayer: () => {},
});

export interface ReaderStateContextProps {
	setMode: (mode: 'replica' | 'responsive' | 'responsive-replica') => void;
	fontSize: number;
	setFontSize: (size: number) => void;
	favorites: Set<number> | null;
	setFavorites: (value: Set<number>) => void;
	onClickLogOut?: () => void;
	audioPlayerUrl: string | null;
	setAudioPlayerUrl: (url: string | null) => void;
	showAudioPlayer: boolean;
	setShowAudioPlayer: (view: boolean) => void;
}
